export default {
  'about.header': 'Hakkımızda',
  'about.update': 'Son güncelleme tarihi',
};
